import { render, staticRenderFns } from "./ErrorMonitor.vue?vue&type=template&id=30bbd1a2&scoped=true"
import script from "./ErrorMonitor.vue?vue&type=script&lang=js"
export * from "./ErrorMonitor.vue?vue&type=script&lang=js"
import style0 from "./ErrorMonitor.vue?vue&type=style&index=0&id=30bbd1a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bbd1a2",
  null
  
)

export default component.exports